import { useEffect, useState } from "react"
import { useParams, Navigate } from "react-router";
import { getDataCot } from "../../Fetch/GetPDF";
import Loading from "../../Components/Loading/Loading";
import LinkPanel from "./LinkPanel"

export default function LinkView() {
  let params = useParams();
  const [data, setData] = useState(
    {
      "status": 'error',
      "message": '',
      "valid": false,
      "payload": {
        "cot": []
      }
    })
  useEffect(() => {
    getDataCot(params.hash, params.id).then(res => {
      if (res.valid) {
        setData(v => (
          {
            ...v,
            status: res.status,
            message: res.message,
            valid: res.valid,
            payload: {
              ...v.payload,
              cot: res.payload.cot,
            }
          }
        ))
      }
    })

  }, [params, setData])

  return (
    data.valid ?
      data.payload.cot.length > 0 ?
        data.payload.cot.map((cot, icot) => (
          cot.oc.length <= 0 && cot.trk.length <= 0 && cot.files.length <= 0 ?
            <Navigate to={`/LinkCot/${params.hash}/${cot.idCotizacion}`} />
            :
            <LinkPanel key={icot} idC={cot.idCotizacion} hash={params.hash} data={cot} />
        ))
        :
        <div>No existen archivos</div>

      :
      <Loading />
  )


}